"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LABELS: {
    Cts: 'Techs',
    Pms: 'Managers',
    Regulatorystatuses: 'Regulatory Statuses',
    Surveytypes: 'Survey Types',
    Targagroupstatuses: 'Targa Group Status',
    Projecttypes: 'Project Type',
    Reporttypes: 'Report Type',
    Reportstatuses: 'Report Status',
    Remediationstatuses: 'Remediation Status'
  },
  ABBRV: {
    Targagroupstatuses: 'Group Status',
    'Targa Group Status': 'Targa Status'
  },
  VIEWS: {
    CUSTOMER_ADMIN_SETTINGS: {
      LABELS: {
        'Enable Lines List Cards View': 'Enable Cards View',
        'Enable Lines List Table View': 'Enable Table View',
        'Enable Report List Action Plan And Closure V1': 'Enable V1:Custom Reports <br/><small>action plan / closure</small>',
        'Enable Report List Action Plan And Closure V2': 'Enable V2:Custom Reports <br/><small>action plan / closure</small>',
        'Enable Report Percent Passing': 'Enable Percent Passing',
        'Enable Report Total Miles': 'Enable Total Miles'
      }
    },
    DOWNLOAD_LINES_AGGS_SUMMARY_CSV: {
      LABELS: {
        customerName: 'customer_name',
        lineName: 'line_name',
        jobNumbers: 'job_numbers',
        cts: 'technicians',
        pms: 'project_managers',
        pipeIDs: 'pipeids',
        regulatoryStatuses: 'regulatory_statuses',
        surveyTypes: 'survey_types',
        txtStartEnd: 'survey_start_end_dates',
        miles: 'survey_miles',
        bcPercentage: 'survey_bc_percentages_off'
      }
    },
    DOWNLOAD_REPORT_AGGS_CSV: {
      LABELS: {
        customerName: 'customer_name',
        parentName: 'line_name',
        entityName: 'entity',
        areaName: 'area',
        pipeName: 'pipe',
        regulatoryStatusName: 'regulatory_status',
        jobNumber: 'job_number',
        txtStartEnd: 'primary_survey_start_end_dates',
        surveyType: 'primary_survey_type',
        projectManagerName: 'project_manager',
        technicianName: 'technician',
        ownerName: 'created_by',
        reportSupervisorName: 'report_supervisor',
        reportPrimaryTechName: 'report_primary_tech'
      }
    },
    DOWNLOAD_REPORT_AGGS_POWER_BI_EXPORT_CSV: {
      LABELS: {
        customerName: 'customer_name',
        parentName: 'line_name',
        entityName: 'entity',
        areaName: 'area',
        pipeName: 'pipe',
        regulatoryStatusName: 'regulatory_status',
        jobNumber: 'job_number',
        txtStartEnd: 'primary_survey_start_end_dates',
        surveyType: 'primary_survey_type',
        projectManagerName: 'project_manager',
        technicianName: 'technician',
        ownerName: 'created_by',
        reportSupervisorName: 'report_supervisor',
        reportPrimaryTechName: 'report_primary_tech'
      }
    }
  }
};
exports["default"] = _default;